import { Tooltip } from '@mui/material';
import { Stack } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { CustomChip } from 'src/shared/components/organisms/customChip';
import { PaymentsStatusEnum } from 'src/shared/models/enums/paymentsStatus.enum';

type PaymentStatusesProps = {
  status: number;
  chipSize: 'small' | 'medium' | undefined;
};

export const PaymentStatuses = (props: PaymentStatusesProps) => {
  const { status, chipSize } = props;
  const { t } = useTranslation();
  return (
    <Stack direction='row' spacing={1} sx={{ '& .MuiChip-filled ': { borderRadius: 1 } }}>
      {status === PaymentsStatusEnum.Failed ? (
        <Tooltip describeChild title={`${t('invoice:payments.statusFailed')}`} arrow>
          <CustomChip label={t('invoice:payments.statusFailed')} color='error' size={chipSize} />
        </Tooltip>
      ) : (
        <Tooltip describeChild title={`${t('invoice:payments.statusCompleted')}`} arrow>
          <CustomChip label={t('invoice:payments.statusCompleted')} color='success' size={chipSize} />
        </Tooltip>
      )}
    </Stack>
  );
};
